export const environment = {
  production: false,
  name: 'dev',
  encryptionKey: 'enterprise-sms-frontend',
  apiPrefix: 'https://api-beta-portal.tecksms.com/api/v1',
  auth: {
    login: '/auth/login',
    signup: '/auth/signup'
  },
  message: {
    statistics: '/message/statistics',
    validateGSM: '/message/validate/gsm',
    sendMessage: '/message/send',
    messageHistory: '/message/history',
    downloadMessageHistory: '/message/download/history',
    scheduledCampaign: '/message/scheduled/campaign',
    downloadScheduledCampaign: '/message/download/scheduled/campaign',
    deleteScheduledCampaign: '/message/cancel/campaign',
    campaign: '/message/campaign',
    validateCampaign: '/message/campaign/validate',
    downloadSampleCampaign: '/message/download/sample/campaign'
  },
  package: {
    packages: '/packages',
    packageList: '/packages/list',
    addPackage: '/packages/add'
  },
  user: {
    user: '/user',
    userList: '/user/list',
    resellers: '/user/reseller',
    companyList: '/user/company/list'
  },
  userPackage: {
    resellersPackages: '/user-packages/resellers'
  }
};
